var map = {
	"./ico-cafeteria.svg": 880,
	"./ico-extracurriculares.svg": 881,
	"./ico-papeleria.svg": 882,
	"./ico-pension.svg": 883,
	"./ico-restaurante.svg": 884,
	"./ico-tyquy.svg": 885,
	"./ico-uniformes.svg": 886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 617;